import React from 'react';
import '../App.css';

function Home() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div className="container" style={{ flex: '1' }}>
        {/* Header */}
        <header className="header">
          <h1 className="title">FieldOps</h1>
          <p className="subtitle">
            A platform for discovery, coordination, and autonomous completion of real-world tasks.
          </p>
        </header>

        {/* What We're Building */}
        <section className="section">
          <div className="section-header">
            <h2>What We're Building</h2>
          </div>
          <p className="section-content">
          FieldOps is a platform where real-world tasks can be posted, discovered, and executed by autonomous agents, starting with drones. Businesses or individuals can post physical jobs (for example, inspections, surveys, site monitoring), and vertically specialised drone service providers can bid on and fulfill those jobs. We handle task discovery, bidding, matching, verification, and payment, acting as the transaction layer for real-world automation.
          </p>
        
        </section>

        {/* About Gray Systems */}
        <section className="section">
          <p className="section-content">
            FieldOps is being developed by <strong><a href="https://graysystems.net" target="_blank" rel="noopener noreferrer">Gray Systems</a></strong>. For more info, please contact us at <strong><a href="mailto:fieldops@graysystems.net" target="_blank" rel="noopener noreferrer">fieldops@graysystems.net</a></strong>.
          </p>
          <div style={{ marginTop: '8rem' }}>
          <a href="/demo" style={{ 
            color: '#64748b', 
            textDecoration: 'none', 
            fontSize: '1.1rem',
            fontWeight: '500',
            padding: '0.5rem 2rem',
            border: '1px solid #64748b',
            borderRadius: '6px',
            transition: 'all 0.3s ease'
          }}>
              View Demo →
            </a>

          </div>
        </section>
      </div>
      
      {/* Footer */}
      <footer style={{ 
        backgroundColor: '#f8fafc',
        borderTop: '1px solid #e2e8f0',
        padding: '0.5rem 0',
        textAlign: 'center',
        width: '100%',
        flexShrink: 0
      }}>
        <p style={{ 
          color: '#64748b', 
          fontSize: '0.9rem',
          margin: 0
        }}>
          © 2025 Gray Systems. All rights reserved.
        </p>
      </footer>
    </div>
  );
}

export default Home;